export default class PerLevelData {
  constructor(lvlNr) {
    this._init(lvlNr);
  }

  async _init(lvlNr) {
    this._currentUserScore = 0;

    const lvlId = G.json.levels.order[lvlNr - 1] || lvlNr;
    try {
      this._data = await OMT.leaderboards.getLeaderBoardEntries('default',lvlId);
      this._data.sort((a, b) => b.score - a.score);
      this._getCurrentUserScore(this._data);
    } catch (error) {
      this._data = null;
    }
  }

  _getCurrentUserScore(data) {
    const currentUser = data.find((user) => user.isCurrentUser);

    if (currentUser) {
      this._currentUser = currentUser;
      this._currentUserScore = currentUser.score;
    }
  }

  passLevel(score) {
    const oldScore = this._currentUserScore || 0;

    const result = {
      leaderboard: null,
      passed: this._getPassedFriends(oldScore, score),
      scoreImprovement: score > oldScore,
      scoreImprovementDelta: score - oldScore,
      requestFriendsUpdate: true,
    };

    if (!this._data) {
      // there was no prelevel data
      return result;
    }

    if (this._currentUser) {
      this._currentUserScore = Math.max(oldScore, score);
    } else {
      // Create whole user element
      this._data.push({
        userId: OMT.envData.settings.user.userId,
        name: OMT.envData.settings.user.name,
        image: OMT.envData.settings.user.avatar,
        score,
        isCurrentUser: true,
      });
    }

    this._data.sort((a, b) => b.score - a.score);
    this._data.forEach((user, i) => {
      user.rank = i + 1;
    });

    result.leaderboard = this._data;
    return result;
  }

  _getPassedFriends(oldScore, newScore) {
    if (!this._data) return null;
    if (oldScore >= newScore) return null;

    // Check filter people who had higher than old score
    const peopleAhead = this._data.filter((user) => !user.isCurrentUser && user.score > oldScore && user.score < newScore);

    return peopleAhead || null;
  }
}
